import styled from 'styled-components';
const Img = styled.img ``;
const SimpleImageStyles = {
    Img,
};
export default SimpleImageStyles;
